import React from 'react';
import styled from 'styled-components';
import { themeGet, sx } from '../..';
const labelStyles = {
  display: 'grid',
  gridAutoColumns: '1fr',
  gridAutoRows: 'min-content',
  color: themeGet('colors.text.default'),
  cursor: 'default',
  fontFamily: themeGet('fontFamily.normal')
};
const textLabelLayoutStyles = {
  gap: '0px 4px',
  gridTemplateColumns: 'min-content auto'
};
const disabledStyles = {
  color: themeGet('colors.text.disabled'),
  cursor: 'not-allowed'
};
export const AtlasCheckboxLabel = ({
  children,
  isDisabled,
  testId,
  onClick,
  label,
  labelSize = 'default',
  id
}) => {
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions
    React.createElement(React.Fragment, null, label ? /*#__PURE__*/React.createElement(StyledLabel, {
      sx: {
        ...labelStyles,
        ...textLabelLayoutStyles
      },
      "data-testid": testId,
      "data-disabled": isDisabled || undefined,
      onClick: onClick,
      labelSize: labelSize,
      id: id
    }, children) : null)
  );
};
const StyledLabel = styled.label.withConfig({
  displayName: "AtlasCheckboxLabel__StyledLabel",
  componentId: "sc-yw2wo5-0"
})(["font-size:", ";", ""], p => p.labelSize === 'default' ? themeGet('fontSizes.2') : p.labelSize === 'small' ? '12px' : 'revert', sx);